

import "src/assets/css/laodingPage.css"

export default function LoadingPage(){


    return(
        <section className="loading-page-audit">
            <div className="loading-page-audit-spinner">
                <div></div>   
                <div></div>    
                <div></div>    
                <div></div>    
            </div>
        </section>
    )
}